'use client'

import { useEffect } from 'react'
import { analytics } from '@/tools/analytics'
import { initAuth } from '@/tools/auth'
import { injectAppVersion } from '@/tools/config'
import { InjectCookieScripts } from '@/tools/cookies-blocker/ui/InjectCookiesBlockerScripts'
import { initDeviceDetection } from '@/tools/device-detection'
import { glovoRum, initObservability } from '@/tools/o11y/client'
import { InjectAntiphishingScript } from '@/tools/security-antiphising/InjectAntiphisingScript'
import { initToggles } from '@/tools/toggles/client'
import type { TogglesDefinitions } from '@/tools/toggles/types'
import { SnackbarContainer } from '@/tools/ui'
import { InitPintxo } from '@/tools/ui/config/client'

const initClient = async (toggles?: TogglesDefinitions) => {
  injectAppVersion()
  initAuth()
  initToggles(toggles)
  await Promise.all([initDeviceDetection(), analytics.init()])
}

export const InitClient = ({ toggles }: { toggles?: TogglesDefinitions }) => {
  // eslint-disable-next-line o11y-guard/error-tracking
  useEffect(() => {
    initObservability()
    initClient(toggles).catch((e) => glovoRum.addError(e, {}))
  }, [toggles])

  return (
    <>
      <InjectCookieScripts />
      <SnackbarContainer />
      <InitPintxo />
      <InjectAntiphishingScript />
    </>
  )
}
